import { render, staticRenderFns } from "./ScoreChip.vue?vue&type=template&id=04f9992b&"
import script from "./ScoreChip.vue?vue&type=script&lang=ts&"
export * from "./ScoreChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports